import { render, staticRenderFns } from "./Policy-subscription.vue?vue&type=template&id=2f5180ff&scoped=true&"
import script from "./Policy-subscription.vue?vue&type=script&lang=js&"
export * from "./Policy-subscription.vue?vue&type=script&lang=js&"
import style0 from "./Policy-subscription.vue?vue&type=style&index=0&id=2f5180ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5180ff",
  null
  
)

export default component.exports